const INTERNAL_NO_EMAIL_DOMAIN = 'noemail.icctmemphis.org';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const sanitizeEmail = (email) => String(email || '').trim().replace(/\s+/g, '').toLowerCase();

export const isValidEmail = (email) => EMAIL_REGEX.test(sanitizeEmail(email));

export const isInternalNoEmail = (email) => {
  const clean = sanitizeEmail(email);
  return clean.endsWith(`@${INTERNAL_NO_EMAIL_DOMAIN}`);
};

const normalizeNamePart = (value, fallback) => {
  const cleaned = String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-+/g, '-');
  return cleaned || fallback;
};

export const buildInternalNoEmail = (firstName, lastName, suffix) => {
  const first = normalizeNamePart(firstName, 'devotee');
  const last = normalizeNamePart(lastName, 'user');
  const normalizedSuffix = String(suffix || '').replace(/\D/g, '').slice(0, 5).padStart(5, '0');
  return `${first}-${last}-${normalizedSuffix}@${INTERNAL_NO_EMAIL_DOMAIN}`;
};

export const generateInternalNoEmail = (firstName, lastName) => {
  const suffix = String(Math.floor(10000 + Math.random() * 90000));
  return buildInternalNoEmail(firstName, lastName, suffix);
};

export { INTERNAL_NO_EMAIL_DOMAIN };
